import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { ReviewIdEnum } from '@app/core';
import { ProductGrade } from '@app/core/interfaces';
import { ProductGradeKeyValue } from '@app/store/product-grade/product-grade-key-value.interface';
import { ProductGradeService } from '@app/store/product-grade/product-grade.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'ins-product-grade-hand-container',
    template: `
        <ins-product-grade-hand
            [productGrade]="productGrade$ | async">
        </ins-product-grade-hand>
    `,
})

export class ProductGradeHandContainer implements OnChanges, OnInit {
    @Input() reviewId: ReviewIdEnum;

    public productGrade$: Observable<ProductGrade>;

    constructor(
        private productGradeService: ProductGradeService,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {
    }

    ngOnInit(): void {
        this.getProductGrade();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.product_name) {
            this.getProductGrade();
        }
    }

    private getProductGrade(): void {
        if (isPlatformBrowser(this.platformId) && this.reviewId) {
            this.productGrade$ = this.productGradeService.getProductGradeByReviewId$(this.reviewId).pipe(
                map((productGradeKeyValue: ProductGradeKeyValue) => productGradeKeyValue?.value),
            );
            this.productGradeService.loadGradeByReviewId(this.reviewId);
        }
    }
}
